import Terria from "../Terria";
import { runInAction } from "mobx";

/**
 * Model for SelectableDimensionWorkflow. Basically just includes a bunch of selectableDimensions, name, icon and a catalog member.
 * This can be used to create "workflows" that display SelectableDimensions in a side panel above the Workbench
 *
 * See `lib/ReactViews/Workflow/Workflows/SelectableDimension/SelectableDimensionWorkflow.tsx` for more info and usage
 */

/**
 * Runs a selectable dimension workflow which is a workflow for a workbench item.
 *
 * @param viewStateOrTerria - The {@link ViewState} or {@link Terria} instance
 * @param workflow - A {@link SelectableDimensionWorkflow} instance
 */
export function runWorkflow(viewStateOrTerria, workflow) {
  runInAction(() => {
    const terria = viewStateOrTerria instanceof Terria ? viewStateOrTerria : viewStateOrTerria.terria;
    terria.selectableDimensionWorkflow = workflow;
  });
}

/** This is essentially the same as `SelectableDimensionGroup`, but allows two levels of nested `SelectableDimensionGroup`, instead of one */